/*enabling-remote-caching*/
/*running-tasks-in-ci*/
/*filtering-for-entry-points*/
/*docker*/
/*skipping-tasks-and-other-unnecessary-work*/
/*running-only-affected-tasks*/
/*using---affected-in-github-actions*/
/*using-turbo-ignore*/
/*checkout-the-repository*/
/*run-turbo-ignore-for-the-package-and-task*/
/*handle-the-result*/
/*best-practices*/
/*rely-on-caching*/
/*global-turbo-in-ci*/
/*use-turbo-run-in-ci*/
/*troubleshooting*/
/*hitting-cache-results-in-broken-builds*/
/*deployment-using-the-wrong-environment-variables*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "构建 CI",
  "description": "了解 Turborepo 如何帮助你高效地完成所有必要的任务并加速你的开发工作流程。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 可以加快构建、lint、测试以及你在持续集成流水线中需要执行的任何其他任务的速度。通过并行化和 远程缓存，Turborepo 可以显著加快你的 CI 速度。"
  }, {
    "heading": "",
    "content": "¥Turborepo speeds up builds, lints, tests, and any other tasks that you need to do in your Continuous Integration pipelines. Through parallelization and Remote Caching, Turborepo makes your CI dramatically faster."
  }, {
    "heading": "",
    "content": "有关如何将你的 CI 供应商连接到远程缓存并运行任务的示例，请访问我们的 CI 指南。"
  }, {
    "heading": "",
    "content": "¥For examples of how to connect your CI vendor to Remote Cache and run tasks, visit our CI guides."
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "¥Enabling Remote Caching"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "要为你的 CI 启用远程缓存，请设置 Turborepo 的环境变量以访问你的远程缓存。"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "¥To enable Remote Caching for your CI, setup the environment variables for Turborepo to access your Remote Cache."
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "环境变量"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "描述"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "用于访问远程缓存的 Bearer 令牌"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "TURBO_TEAM"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "与你的仓库关联的账户名。使用 ' ' Vercel Remote Cache 时，此变量设置为 你团队的 slug。"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "当你通过 turbo 运行任务时，你的 CI 将能够命中缓存，从而加快你的流水线速度。"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "¥When you run tasks through turbo, your CI will be able to hit cache, speeding up your pipelines."
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "Vercel 内置的 CI/CD 可自动连接到你托管的 Vercel 远程缓存，且无需配置。要获取用于将其他 CI 供应商连接到 Vercel 远程缓存的令牌，请访问 Vercel 远程缓存文档。"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "¥Vercel's built-in CI/CD is automatically connected to your managed Vercel Remote Cache with zero configuration. To retrieve a token for connecting your other CI vendors to Vercel Remote Cache, visit the Vercel Remote Cache documentation."
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "有关自托管远程缓存选项，请访问 Turborepo 的远程缓存文档。"
  }, {
    "heading": "启用远程缓存-enabling-remote-caching",
    "content": "¥For self-hosted Remote Cache options, visit Turborepo's Remote Cache documentation."
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "¥Running tasks in CI"
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "通过将 全局安装 turbo 部署到你的开发和 CI 机器上，你可以使用一个思维模型来运行你的整个仓库，从开发到发布。你在 turbo.json 中注册的任务将在 CI 中完全相同地工作。"
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "¥By installing turbo globally onto your development and CI machines, you can use one mental model to run your entire repository, from development to ship. The tasks that you've registered in your turbo.json will work exactly the same in CI."
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "更多有关如何设置任务的信息，请访问 配置任务 页面。"
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "¥For more information on how to set up tasks, visit the Configuring Tasks page."
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "有关在 CI 中运行任务的示例，请访问我们的 CI 指南。"
  }, {
    "heading": "正在运行任务-ci-running-tasks-in-ci",
    "content": "¥For examples of running tasks in CI, visit our CI guides."
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "¥Filtering for entry points"
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "你可以使用 --filter 标志 过滤任务，就像在本地使用 turbo 一样。CI 支持按包、目录和 Git 历史记录进行过滤。"
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "¥You can filter your tasks using the --filter flag exactly the same as when you're working with turbo locally. Filtering by packages, directories, and Git history are all supported in CI."
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "只有当计算机上有历史记录时，才能使用源代码控制更改进行过滤。如果你使用的是浅克隆，则历史记录将不可用。"
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "¥Filtering using source control changes is only possible when history is\navailable on the machine. If you are using shallow clones, history will not be\navailable."
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "你还可以使用 --affected 标志 仅运行发生更改的包中的任务。"
  }, {
    "heading": "按入口点过滤-filtering-for-entry-points",
    "content": "¥You can also use the --affected flag to only run tasks in packages that have changes."
  }, {
    "heading": "docker-docker",
    "content": "Docker 是许多部署流水线的重要组成部分。Turborepo 的 prune 子命令 可帮助你从镜像中删除不必要的依赖和代码，从而交付轻量级镜像。"
  }, {
    "heading": "docker-docker",
    "content": "¥Docker is an important part of many deployment pipelines. Turborepo's prune subcommand helps you ship lightweight images by removing unnecessary dependencies and code from your images."
  }, {
    "heading": "docker-docker",
    "content": "关于如何使用 Docker 从 Turborepo 部署的更多信息，请访问 Docker 专用指南。"
  }, {
    "heading": "docker-docker",
    "content": "¥For more on how to deploy from a Turborepo with Docker, visit the dedicated Docker guide."
  }, {
    "heading": "跳过任务和其他不必要的工作-skipping-tasks-and-other-unnecessary-work",
    "content": "¥Skipping tasks and other unnecessary work"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥Running only affected tasks"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "你可以使用 --affected 标志仅运行有更改的任务。"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥You can use the --affected flag to only run tasks that have changes."
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "你需要在以下情况下使用此标志："
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥You'll want to use this flag in situations like:"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "你正在 monorepo 中的包之间运行许多任务，并且只想在代码发生更改的包中运行这些任务。"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥You're running many tasks across packages in your monorepo, and only want to run those tasks in packages with code changes."
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "你没有使用远程缓存，但仍希望在 CI 中尽可能少地工作。"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥You’re not using a Remote Cache, but still want to do as little work as possible in CI."
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "你正在使用远程缓存，并且你的代码库很大。通过最小化从缓存中恢复的任务量，可以减少通过网络发送的数据量，从而加快缓存恢复速度。"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥You are using a Remote Cache, and you’re in a large repository. By minimizing the amount of tasks that will be restored from cache, there will be less data to send across the network, resulting in faster cache restoration."
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "你已经在使用 高级过滤技术 或 turbo-ignore 来创建与 --affected 相同或类似的行为。你很可能有机会使用此新标志简化脚本编写。"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥You’re already using advanced filtering techniques or turbo-ignore to create the same or similar behavior as --affected. You likely have the opportunity to simplify your scripting using this new flag."
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "--affected 可以比定制过滤更优雅地处理浅克隆，因为它会回退到运行所有任务。"
  }, {
    "heading": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "¥--affected will can handle shallow clones more gracefully than bespoke filtering because it falls back to running all tasks."
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "¥Using --affected in GitHub Actions"
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "CI/CD 流水线是使用 --affected 的理想场所。使用 --affected，Turborepo 可以通过检查 GitHub 设置的环境变量（例如 GITHUB_BASE_REF）自动检测你是否正在 GitHub Actions 中运行。"
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "¥CI/CD pipelines are a perfect place to use --affected. With --affected, Turborepo can automatically detect that you're running in GitHub Actions by inspecting environment variables set by GitHub, like GITHUB_BASE_REF."
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "在 PR 上下文中，这意味着 Turborepo 可以确定 PR 的基础分支和 PR 的头分支之间哪些包发生了更改。这允许你仅针对受 PR 中更改影响的包运行任务。"
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "¥In the context of a PR, this means that Turborepo can determine which packages have changed between the PR's base branch and the PR's head branch. This allows you to run tasks only for the packages that are affected by the changes in the PR."
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "GITHUB_BASE_REF 在 pull_request 和 pull_request_target 事件中运行良好，但在常规推送事件期间不可用。在这种情况下，我们使用 GITHUB_EVENT_PATH 来确定要与你的提交进行比较的基准分支。在强制推送和推送没有额外提交的分支时，我们会将其与分支上第一个提交的父级进行比较。"
  }, {
    "heading": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "¥While GITHUB_BASE_REF works well in pull_request and pull_request_target events, it is not available during regular push events. In those cases, we use GITHUB_EVENT_PATH to determine the base branch to compare your commit to. In force pushes and pushing branch with no additional commits, we compare to the parent of the first commit on the branch."
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥Using turbo-ignore"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "随着代码库和持续集成 (CI) 的增长，你可能会开始寻找更多方法来提高速度。虽然缓存很有用，但你也可以完全跳过这些工作。使用 turbo-ignore，你可以跳过冗长的容器准备步骤，例如依赖安装，这些步骤最终会导致缓存命中。"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥As your codebase and CI grow, you may start to look for more ways to get even faster. While hitting cache is useful, you also may be able to skip work entirely. Using turbo-ignore, you can skip lengthy container preparation steps like dependency installation that will end up resulting in a cache hit, anyway."
  }, {
    "heading": "检出代码库-checkout-the-repository",
    "content": "¥Checkout the repository"
  }, {
    "heading": "检出代码库-checkout-the-repository",
    "content": "首先克隆你的代码库。请注意，你需要一个具有你计划使用的克隆深度历史记录的克隆，以便进行比较。"
  }, {
    "heading": "检出代码库-checkout-the-repository",
    "content": "¥Start by cloning your repository. Note that a clone with history to the cloning depth you plan on using is necessary for comparisons."
  }, {
    "heading": "检出代码库-checkout-the-repository",
    "content": "默认情况下，turbo-ignore 使用父提交。要进行更深入的自定义，请参阅 turbo-ignore 参考。"
  }, {
    "heading": "检出代码库-checkout-the-repository",
    "content": "¥By default, turbo-ignore uses the parent commit. To customize for more\ndepth, see the turbo-ignore reference."
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥Run turbo-ignore for the package and task"
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "默认情况下，turbo-ignore 将在当前工作目录中使用 build 任务。"
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥By default, turbo-ignore will use the build task in the current working directory."
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "要检查其他任务的更改，请使用 --task 标志。"
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥To check for changes to a different task, use the --task flag."
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "要检查特定包及其依赖的更改，请添加包名称作为参数。"
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥To check for changes for a specific package and its dependencies, add the package's name as an argument."
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "通过将 web 包添加为参数，检查 web 包及其依赖的 build 任务的更改："
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥Check for changes for the build task for the web package and its dependencies by adding the web package as an argument:"
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "使用 自动确定软件包作用域 检查 web 包及其依赖的 build 任务的更改："
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥Check for changes for the build task for the web package and its dependencies using Automatic Package Scoping:"
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "使用 自动确定软件包作用域 和 --task 标志检查 docs 包及其依赖的 test 任务的更改："
  }, {
    "heading": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "¥Check for changes for the test task for the docs package and its dependencies using Automatic Package Scoping and the --task flag:"
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "¥Handle the result"
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "如果在包或其 内部依赖 中检测到更改，turbo 将退出并返回 1 状态码。如果没有检测到任何更改，它将退出并运行 0。"
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "¥If changes are detected in the package or its Internal Dependencies, turbo will exit with a 1 status code. If no changes are detected, it will exit with 0."
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "使用此状态代码，你可以选择 CI 管道的其余部分应执行的操作。例如，1 退出代码可能意味着你应该继续安装依赖并运行任务。"
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "¥Using this status code, you can choose what the rest of your CI pipeline should do. For instance, a 1 exit code likely means that you should move forward with installing dependencies and running tasks."
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "有关更高级的用例，请参阅 turbo-ignore 参考。"
  }, {
    "heading": "处理结果-handle-the-result",
    "content": "¥For more advanced use cases, see the turbo-ignore reference."
  }, {
    "heading": "最佳实践-best-practices",
    "content": "¥Best practices"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "¥Rely on caching"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "Turborepo 的缓存功能允许你以最小的复杂性创建快速的 CI 流水线。通过 远程缓存 并使用 --filter 标志来定位要构建的包，Turborepo 将以很小的开销处理大型 monorepo 的变更检测。"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "¥Turborepo's caching abilities allow you to create fast CI pipelines with minimal complexity. Through Remote Caching and using the --filter flag to target packages for builds, Turborepo will handle change detection for large monorepos with little overhead."
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "例如，你的 CI 可以运行这两个命令来快速进行质量检查并构建目标应用："
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "¥For example, your CI could run these two commands to quickly handle quality checks and build your target application:"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "turbo run lint check-types test：对整个仓库运行质量检查。任何未更改的包都将进入缓存。"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "¥turbo run lint check-types test: Run quality checks for your entire repository. Any packages that haven't changed will hit cache."
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "turbo build --filter=web：使用你在 turbo.json 中注册的 build 任务构建 web 包。如果 web 包或其依赖没有更改，构建也会命中缓存。"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "¥turbo build --filter=web: Build the web package using the build task you've registered in turbo.json. If the web package or its dependencies haven't changed, the build will also hit cache."
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "随着代码库的扩展，你可能会发现更多优化 CI 的具体机会。 - 但依赖缓存是一个很好的起点。"
  }, {
    "heading": "依赖缓存-rely-on-caching",
    "content": "¥As your codebase scales, you may find more specific opportunities to optimize your CI - but relying on caching is a great place to start."
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "¥Global turbo in CI"
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "在 CI 工作流中使用全局 turbo 非常方便，让你可以轻松运行特定于 CI 的命令并利用 自动工作区作用域。"
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "¥Using global turbo is convenient in CI workflows, allowing you to easily run commands specific to your CI and take advantage of Automatic Workspace Scoping."
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "但是，在某些情况下，你可能在使用包管理器安装包之前运行了使用 turbo 的 turbo 命令或脚本。使用 turbo prune 创建 Docker 镜像 就是一个例子。在这种情况下，全局 turbo 将无法使用 package.json 中的版本，因为该版本的二进制文件尚未安装。"
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "¥However, in some cases, you may be running turbo commands or scripts that use turbo before installing packages with your package manager. One example of this is using turbo prune to create a Docker image. In this situation, global turbo will not be able to use the version from package.json because the binary for that version hasn't been installed yet."
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "因此，我们建议你将 CI 中 turbo 的全局安装固定到 package.json 的主版本，因为重大更改不会在主版本中引入。你还可以选择通过固定确切版本来提高稳定性，以维护负担为代价来接收补丁版本中的错误修复。"
  }, {
    "heading": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "¥For this reason, we encourage you to pin your global installation of turbo in CI to the major version in package.json since breaking changes will not be introduced within a major version. You could additionally opt for added stability by pinning an exact version, trading off for maintenance burden to receive bug fixes in patch releases."
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "¥Use turbo run in CI"
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "turbo run 是你在 Turborepo 中工作时最常用的命令，因此为了方便起见，它被别名为 turbo。虽然这对于本地工作非常有用，但还有其他适用于 turbo 的子命令，例如 turbo prune 和 turbo generate。"
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "¥turbo run is the most common command you will use when working in your Turborepo so it is aliased to turbo for convenience. While this is great for working locally, there are other subcommands for turbo like turbo prune and turbo generate."
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "我们一直在努力改进 turbo，因此未来可能会添加更多子命令。因此，你可以通过在 CI 中使用 turbo run 来防止命名冲突。"
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "¥We're always working to make turbo better so we may add more subcommands in the future. For this reason, you can prevent naming collisions by using turbo run in your CI."
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "例如，如果你的 CI 管道中有一个 turbo deploy 命令，它可能与直接内置于 turbo CLI 中的潜在 deploy 子命令冲突。为避免这种情况，请在你的 CI 管道中使用 turbo run deploy。"
  }, {
    "heading": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "¥As an example, if you have a turbo deploy command in your CI pipelines, it may conflict with a potential deploy subcommand built directly into the turbo CLI. To avoid this, use turbo run deploy in your CI pipeline instead."
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "¥Troubleshooting"
  }, {
    "heading": "访问缓存导致构建失败-hitting-cache-results-in-broken-builds",
    "content": "¥Hitting cache results in broken builds"
  }, {
    "heading": "访问缓存导致构建失败-hitting-cache-results-in-broken-builds",
    "content": "如果你的任务在缓存丢失时通过，但在缓存命中时失败，则你可能没有正确配置任务的 outputs 键。"
  }, {
    "heading": "访问缓存导致构建失败-hitting-cache-results-in-broken-builds",
    "content": "¥If your task is passing when you miss cache but failing when you hit cache, you likely haven't configured the outputs key for your task correctly."
  }, {
    "heading": "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
    "content": "¥Deployment using the wrong environment variables"
  }, {
    "heading": "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
    "content": "如果你没有为任务定义 env 或 globalEnv 键，Turborepo 将无法在创建哈希时使用它们。这意味着你的任务即使在不同的环境中也能命中缓存。"
  }, {
    "heading": "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
    "content": "¥If you haven't defined the env or globalEnv keys for your task, Turborepo will not be able to use them when creating hashes. This means your task can hit cache despite being in a different environment."
  }, {
    "heading": "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
    "content": "检查 env 和 globalEnv 键的配置。"
  }, {
    "heading": "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
    "content": "¥Check your configuration for the env and globalEnv keys."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "现在，你已拥有使用 Turborepo 交付应用所需的一切。要了解更多关于具体用例的信息，请参阅 查看指南 或 深入了解核心概念。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥You now have everything you need to ship applications with Turborepo. To learn more about specific use cases, check the Guides or dive deeper into core concepts."
  }],
  "headings": [{
    "id": "启用远程缓存-enabling-remote-caching",
    "content": "启用远程缓存 /*enabling-remote-caching*/"
  }, {
    "id": "正在运行任务-ci-running-tasks-in-ci",
    "content": "正在运行任务 CI /*running-tasks-in-ci*/"
  }, {
    "id": "按入口点过滤-filtering-for-entry-points",
    "content": "按入口点过滤 /*filtering-for-entry-points*/"
  }, {
    "id": "docker-docker",
    "content": "Docker /*docker*/"
  }, {
    "id": "跳过任务和其他不必要的工作-skipping-tasks-and-other-unnecessary-work",
    "content": "跳过任务和其他不必要的工作 /*skipping-tasks-and-other-unnecessary-work*/"
  }, {
    "id": "仅运行受影响的任务-running-only-affected-tasks",
    "content": "仅运行受影响的任务 /*running-only-affected-tasks*/"
  }, {
    "id": "在-github-actions-中使用---affected-using---affected-in-github-actions",
    "content": "在 GitHub Actions 中使用 --affected /*using---affected-in-github-actions*/"
  }, {
    "id": "使用-turbo-ignore-using-turbo-ignore",
    "content": "使用 turbo-ignore /*using-turbo-ignore*/"
  }, {
    "id": "检出代码库-checkout-the-repository",
    "content": "检出代码库 /*checkout-the-repository*/"
  }, {
    "id": "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
    "content": "为包和任务运行 turbo-ignore /*run-turbo-ignore-for-the-package-and-task*/"
  }, {
    "id": "处理结果-handle-the-result",
    "content": "处理结果 /*handle-the-result*/"
  }, {
    "id": "最佳实践-best-practices",
    "content": "最佳实践 /*best-practices*/"
  }, {
    "id": "依赖缓存-rely-on-caching",
    "content": "依赖缓存 /*rely-on-caching*/"
  }, {
    "id": "ci-中的全局-turbo-global-turbo-in-ci",
    "content": "CI 中的全局 turbo /*global-turbo-in-ci*/"
  }, {
    "id": "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
    "content": "在 CI 中使用 turbo run /*use-turbo-run-in-ci*/"
  }, {
    "id": "故障排除-troubleshooting",
    "content": "故障排除 /*troubleshooting*/"
  }, {
    "id": "访问缓存导致构建失败-hitting-cache-results-in-broken-builds",
    "content": "访问缓存导致构建失败 /*hitting-cache-results-in-broken-builds*/"
  }, {
    "id": "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
    "content": "使用错误的环境变量进行部署 /*deployment-using-the-wrong-environment-variables*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Step, Steps} from '#components/steps';
export const toc = [{
  depth: 2,
  url: "#启用远程缓存-enabling-remote-caching",
  title: _jsx(_Fragment, {
    children: "启用远程缓存 "
  })
}, {
  depth: 2,
  url: "#正在运行任务-ci-running-tasks-in-ci",
  title: _jsx(_Fragment, {
    children: "正在运行任务 CI "
  })
}, {
  depth: 3,
  url: "#按入口点过滤-filtering-for-entry-points",
  title: _jsx(_Fragment, {
    children: "按入口点过滤 "
  })
}, {
  depth: 2,
  url: "#docker-docker",
  title: _jsx(_Fragment, {
    children: "Docker "
  })
}, {
  depth: 2,
  url: "#跳过任务和其他不必要的工作-skipping-tasks-and-other-unnecessary-work",
  title: _jsx(_Fragment, {
    children: "跳过任务和其他不必要的工作 "
  })
}, {
  depth: 3,
  url: "#仅运行受影响的任务-running-only-affected-tasks",
  title: _jsx(_Fragment, {
    children: "仅运行受影响的任务 "
  })
}, {
  depth: 4,
  url: "#在-github-actions-中使用---affected-using---affected-in-github-actions",
  title: _jsxs(_Fragment, {
    children: ["在 GitHub Actions 中使用 ", _jsx("code", {
      children: "--affected"
    }), " "]
  })
}, {
  depth: 3,
  url: "#使用-turbo-ignore-using-turbo-ignore",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "turbo-ignore"
    }), " "]
  })
}, {
  depth: 3,
  url: "#检出代码库-checkout-the-repository",
  title: _jsx(_Fragment, {
    children: "检出代码库 "
  })
}, {
  depth: 3,
  url: "#为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
  title: _jsxs(_Fragment, {
    children: ["为包和任务运行 ", _jsx("code", {
      children: "turbo-ignore"
    }), " "]
  })
}, {
  depth: 3,
  url: "#处理结果-handle-the-result",
  title: _jsx(_Fragment, {
    children: "处理结果 "
  })
}, {
  depth: 2,
  url: "#最佳实践-best-practices",
  title: _jsx(_Fragment, {
    children: "最佳实践 "
  })
}, {
  depth: 3,
  url: "#依赖缓存-rely-on-caching",
  title: _jsx(_Fragment, {
    children: "依赖缓存 "
  })
}, {
  depth: 3,
  url: "#ci-中的全局-turbo-global-turbo-in-ci",
  title: _jsxs(_Fragment, {
    children: ["CI 中的全局 ", _jsx("code", {
      children: "turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#在-ci-中使用-turbo-run-use-turbo-run-in-ci",
  title: _jsxs(_Fragment, {
    children: ["在 CI 中使用 ", _jsx("code", {
      children: "turbo run"
    }), " "]
  })
}, {
  depth: 2,
  url: "#故障排除-troubleshooting",
  title: _jsx(_Fragment, {
    children: "故障排除 "
  })
}, {
  depth: 3,
  url: "#访问缓存导致构建失败-hitting-cache-results-in-broken-builds",
  title: _jsx(_Fragment, {
    children: "访问缓存导致构建失败 "
  })
}, {
  depth: 3,
  url: "#使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
  title: _jsx(_Fragment, {
    children: "使用错误的环境变量进行部署 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo 可以加快构建、lint、测试以及你在持续集成流水线中需要执行的任何其他任务的速度。通过并行化和 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), "，Turborepo 可以显著加快你的 CI 速度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo speeds up builds, lints, tests, and any other tasks that you need to do in your Continuous Integration pipelines. Through parallelization and ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), ", Turborepo makes your CI dramatically faster."]
    }), "\n", _jsxs(_components.p, {
      children: ["有关如何将你的 CI 供应商连接到远程缓存并运行任务的示例，请访问我们的 ", _jsx(_components.a, {
        href: "/docs/guides/ci-vendors",
        children: "CI 指南"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For examples of how to connect your CI vendor to Remote Cache and run tasks, visit our ", _jsx(_components.a, {
        href: "/docs/guides/ci-vendors",
        children: "CI guides"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "启用远程缓存-enabling-remote-caching",
      children: "启用远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Enabling Remote Caching"
    }), "\n", _jsx(_components.p, {
      children: "要为你的 CI 启用远程缓存，请设置 Turborepo 的环境变量以访问你的远程缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥To enable Remote Caching for your CI, setup the environment variables for Turborepo to access your Remote Cache."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "环境变量"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_TOKEN"
            })
          }), _jsx(_components.td, {
            children: "用于访问远程缓存的 Bearer 令牌"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_TEAM"
            })
          }), _jsxs(_components.td, {
            children: ["与你的仓库关联的账户名。使用 ", ' ', " ", _jsx("a", {
              href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
              rel: "noreferrer noopener",
              target: "_blank",
              children: "Vercel Remote Cache"
            }), " 时，此变量设置为 ", _jsx(_components.a, {
              href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
              children: "你团队的 slug"
            }), "。"]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["当你通过 ", _jsx(_components.code, {
        children: "turbo"
      }), " 运行任务时，你的 CI 将能够命中缓存，从而加快你的流水线速度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you run tasks through ", _jsx(_components.code, {
        children: "turbo"
      }), ", your CI will be able to hit cache, speeding up your pipelines."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Remote Cache hosting",
      children: [_jsxs(_components.p, {
        children: ["Vercel 内置的 CI/CD 可自动连接到你托管的 Vercel 远程缓存，且无需配置。要获取用于将其他 CI 供应商连接到 Vercel 远程缓存的令牌，请访问 ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching#use-remote-caching-from-external-ci/cd",
          children: "Vercel 远程缓存文档"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥Vercel's built-in CI/CD is automatically connected to your managed Vercel Remote Cache with zero configuration. To retrieve a token for connecting your other CI vendors to Vercel Remote Cache, visit the ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching#use-remote-caching-from-external-ci/cd",
          children: "Vercel Remote Cache documentation"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["有关自托管远程缓存选项，请访问 ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching#remote-cache-api",
          children: "Turborepo 的远程缓存文档"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥For self-hosted Remote Cache options, visit ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching#remote-cache-api",
          children: "Turborepo's Remote Cache documentation"
        }), "."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "正在运行任务-ci-running-tasks-in-ci",
      children: "正在运行任务 CI "
    }), "\n", _jsx(_components.p, {
      children: "¥Running tasks in CI"
    }), "\n", _jsxs(_components.p, {
      children: ["通过将 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["全局安装 ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), " 部署到你的开发和 CI 机器上，你可以使用一个思维模型来运行你的整个仓库，从开发到发布。你在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中注册的任务将在 CI 中完全相同地工作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["installing ", _jsx(_components.code, {
          children: "turbo"
        }), " globally"]
      }), " onto your development and CI machines, you can use one mental model to run your entire repository, from development to ship. The tasks that you've registered in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " will work exactly the same in CI."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["更多有关如何设置任务的信息，请访问 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/configuring-tasks",
            children: "配置任务"
          }), " 页面。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥For more information on how to set up tasks, visit the ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/configuring-tasks",
            children: "Configuring Tasks"
          }), " page."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["有关在 CI 中运行任务的示例，请访问我们的 ", _jsx(_components.a, {
            href: "/docs/guides/ci-vendors",
            children: "CI 指南"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥For examples of running tasks in CI, visit our ", _jsx(_components.a, {
            href: "/docs/guides/ci-vendors",
            children: "CI guides"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "按入口点过滤-filtering-for-entry-points",
      children: "按入口点过滤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering for entry points"
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " 标志"]
      }), " 过滤任务，就像在本地使用 ", _jsx(_components.code, {
        children: "turbo"
      }), " 一样。CI 支持按包、目录和 Git 历史记录进行过滤。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can filter your tasks using ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: ["the ", _jsx(_components.code, {
          children: "--filter"
        }), " flag"]
      }), " exactly the same as when you're working with ", _jsx(_components.code, {
        children: "turbo"
      }), " locally. Filtering by packages, directories, and Git history are all supported in CI."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Using Git history in CI",
      children: [_jsx(_components.p, {
        children: "只有当计算机上有历史记录时，才能使用源代码控制更改进行过滤。如果你使用的是浅克隆，则历史记录将不可用。"
      }), _jsx(_components.p, {
        children: "¥Filtering using source control changes is only possible when history is\navailable on the machine. If you are using shallow clones, history will not be\navailable."
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以使用 ", _jsxs(_components.a, {
        href: "#running-only-affected-tasks",
        children: [_jsx(_components.code, {
          children: "--affected"
        }), " 标志"]
      }), " 仅运行发生更改的包中的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also use ", _jsxs(_components.a, {
        href: "#running-only-affected-tasks",
        children: ["the ", _jsx(_components.code, {
          children: "--affected"
        }), " flag"]
      }), " to only run tasks in packages that have changes."]
    }), "\n", _jsx(_components.h2, {
      id: "docker-docker",
      children: "Docker "
    }), "\n", _jsxs(_components.p, {
      children: ["Docker 是许多部署流水线的重要组成部分。", _jsxs(_components.a, {
        href: "/docs/reference/prune",
        children: ["Turborepo 的 ", _jsx(_components.code, {
          children: "prune"
        }), " 子命令"]
      }), " 可帮助你从镜像中删除不必要的依赖和代码，从而交付轻量级镜像。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Docker is an important part of many deployment pipelines. ", _jsxs(_components.a, {
        href: "/docs/reference/prune",
        children: ["Turborepo's ", _jsx(_components.code, {
          children: "prune"
        }), " subcommand"]
      }), " helps you ship lightweight images by removing unnecessary dependencies and code from your images."]
    }), "\n", _jsxs(_components.p, {
      children: ["关于如何使用 Docker 从 Turborepo 部署的更多信息，请访问 ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "Docker 专用指南"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more on how to deploy from a Turborepo with Docker, visit ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "the dedicated Docker guide"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "跳过任务和其他不必要的工作-skipping-tasks-and-other-unnecessary-work",
      children: "跳过任务和其他不必要的工作 "
    }), "\n", _jsx(_components.p, {
      children: "¥Skipping tasks and other unnecessary work"
    }), "\n", _jsx(_components.h3, {
      id: "仅运行受影响的任务-running-only-affected-tasks",
      children: "仅运行受影响的任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Running only affected tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用 ", _jsx(_components.code, {
        children: "--affected"
      }), " 标志仅运行有更改的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can use the ", _jsx(_components.code, {
        children: "--affected"
      }), " flag to only run tasks that have changes."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "你需要在以下情况下使用此标志："
    }), "\n", _jsx(_components.p, {
      children: "¥You'll want to use this flag in situations like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你正在 monorepo 中的包之间运行许多任务，并且只想在代码发生更改的包中运行这些任务。"
        }), "\n", _jsx(_components.p, {
          children: "¥You're running many tasks across packages in your monorepo, and only want to run those tasks in packages with code changes."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你没有使用远程缓存，但仍希望在 CI 中尽可能少地工作。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥You’re ", _jsx(_components.em, {
            children: "not"
          }), " using a Remote Cache, but still want to do as little work as possible in CI."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你正在使用远程缓存，并且你的代码库很大。通过最小化从缓存中恢复的任务量，可以减少通过网络发送的数据量，从而加快缓存恢复速度。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥You ", _jsx(_components.em, {
            children: "are"
          }), " using a Remote Cache, and you’re in a large repository. By minimizing the amount of tasks that will be restored from cache, there will be less data to send across the network, resulting in faster cache restoration."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你已经在使用 ", _jsx(_components.a, {
            href: "/docs/reference/run#advanced-filtering-examples",
            children: "高级过滤技术"
          }), " 或 ", _jsx(_components.a, {
            href: "/docs/reference/turbo-ignore",
            children: _jsx(_components.code, {
              children: "turbo-ignore"
            })
          }), " 来创建与 ", _jsx(_components.code, {
            children: "--affected"
          }), " 相同或类似的行为。你很可能有机会使用此新标志简化脚本编写。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You’re already using ", _jsx(_components.a, {
            href: "/docs/reference/run#advanced-filtering-examples",
            children: "advanced filtering techniques"
          }), " or ", _jsx(_components.a, {
            href: "/docs/reference/turbo-ignore",
            children: _jsx(_components.code, {
              children: "turbo-ignore"
            })
          }), " to create the same or similar behavior as ", _jsx(_components.code, {
            children: "--affected"
          }), ". You likely have the opportunity to simplify your scripting using this new flag."]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "--affected"
              }), " 可以比定制过滤更优雅地处理浅克隆，因为它会回退到运行所有任务。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.code, {
                children: "--affected"
              }), " will can handle shallow clones more gracefully than bespoke filtering because it falls back to running all tasks."]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.h4, {
      id: "在-github-actions-中使用---affected-using---affected-in-github-actions",
      children: ["在 GitHub Actions 中使用 ", _jsx(_components.code, {
        children: "--affected"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.code, {
        children: "--affected"
      }), " in GitHub Actions"]
    }), "\n", _jsxs(_components.p, {
      children: ["CI/CD 流水线是使用 ", _jsx(_components.code, {
        children: "--affected"
      }), " 的理想场所。使用 ", _jsx(_components.code, {
        children: "--affected"
      }), "，Turborepo 可以通过检查 GitHub 设置的环境变量（例如 ", _jsx(_components.code, {
        children: "GITHUB_BASE_REF"
      }), "）自动检测你是否正在 GitHub Actions 中运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥CI/CD pipelines are a perfect place to use ", _jsx(_components.code, {
        children: "--affected"
      }), ". With ", _jsx(_components.code, {
        children: "--affected"
      }), ", Turborepo can automatically detect that you're running in GitHub Actions by inspecting environment variables set by GitHub, like ", _jsx(_components.code, {
        children: "GITHUB_BASE_REF"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "在 PR 上下文中，这意味着 Turborepo 可以确定 PR 的基础分支和 PR 的头分支之间哪些包发生了更改。这允许你仅针对受 PR 中更改影响的包运行任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥In the context of a PR, this means that Turborepo can determine which packages have changed between the PR's base branch and the PR's head branch. This allows you to run tasks only for the packages that are affected by the changes in the PR."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "GITHUB_BASE_REF"
      }), " 在 ", _jsx(_components.code, {
        children: "pull_request"
      }), " 和 ", _jsx(_components.code, {
        children: "pull_request_target"
      }), " 事件中运行良好，但在常规推送事件期间不可用。在这种情况下，我们使用 ", _jsx(_components.code, {
        children: "GITHUB_EVENT_PATH"
      }), " 来确定要与你的提交进行比较的基准分支。在强制推送和推送没有额外提交的分支时，我们会将其与分支上第一个提交的父级进行比较。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥While ", _jsx(_components.code, {
        children: "GITHUB_BASE_REF"
      }), " works well in ", _jsx(_components.code, {
        children: "pull_request"
      }), " and ", _jsx(_components.code, {
        children: "pull_request_target"
      }), " events, it is not available during regular push events. In those cases, we use ", _jsx(_components.code, {
        children: "GITHUB_EVENT_PATH"
      }), " to determine the base branch to compare your commit to. In force pushes and pushing branch with no additional commits, we compare to the parent of the first commit on the branch."]
    }), "\n", _jsxs(_components.h3, {
      id: "使用-turbo-ignore-using-turbo-ignore",
      children: ["使用 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.code, {
        children: "turbo-ignore"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["随着代码库和持续集成 (CI) 的增长，你可能会开始寻找更多方法来提高速度。虽然缓存很有用，但你也可以完全跳过这些工作。使用 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "，你可以跳过冗长的容器准备步骤，例如依赖安装，这些步骤最终会导致缓存命中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥As your codebase and CI grow, you may start to look for more ways to get even faster. While hitting cache is useful, you also may be able to skip work entirely. Using ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), ", you can skip lengthy container preparation steps like dependency installation that will end up resulting in a cache hit, anyway."]
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "检出代码库-checkout-the-repository",
          children: "检出代码库 "
        }), _jsx(_components.p, {
          children: "¥Checkout the repository"
        }), _jsx(_components.p, {
          children: "首先克隆你的代码库。请注意，你需要一个具有你计划使用的克隆深度历史记录的克隆，以便进行比较。"
        }), _jsx(_components.p, {
          children: "¥Start by cloning your repository. Note that a clone with history to the cloning depth you plan on using is necessary for comparisons."
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsxs(_components.p, {
            children: ["默认情况下，", _jsx(_components.code, {
              children: "turbo-ignore"
            }), " 使用父提交。要进行更深入的自定义，请参阅 ", _jsx(_components.a, {
              href: "/docs/reference/turbo-ignore",
              children: "turbo-ignore 参考"
            }), "。"]
          }), _jsxs(_components.p, {
            children: ["¥By default, ", _jsx(_components.code, {
              children: "turbo-ignore"
            }), " uses the parent commit. To customize for more\ndepth, see ", _jsx(_components.a, {
              href: "/docs/reference/turbo-ignore",
              children: "the turbo-ignore reference"
            }), "."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "为包和任务运行-turbo-ignore-run-turbo-ignore-for-the-package-and-task",
          children: ["为包和任务运行 ", _jsx(_components.code, {
            children: "turbo-ignore"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Run ", _jsx(_components.code, {
            children: "turbo-ignore"
          }), " for the package and task"]
        }), _jsxs(_components.p, {
          children: ["默认情况下，", _jsx(_components.code, {
            children: "turbo-ignore"
          }), " 将在当前工作目录中使用 ", _jsx(_components.code, {
            children: "build"
          }), " 任务。"]
        }), _jsxs(_components.p, {
          children: ["¥By default, ", _jsx(_components.code, {
            children: "turbo-ignore"
          }), " will use the ", _jsx(_components.code, {
            children: "build"
          }), " task in the current working directory."]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["要检查其他任务的更改，请使用 ", _jsx(_components.code, {
                children: "--task"
              }), " 标志。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥To check for changes to a different task, use the ", _jsx(_components.code, {
                children: "--task"
              }), " flag."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: "要检查特定包及其依赖的更改，请添加包名称作为参数。"
            }), "\n", _jsx(_components.p, {
              children: "¥To check for changes for a specific package and its dependencies, add the package's name as an argument."
            }), "\n"]
          }), "\n"]
        }), _jsxs(Tabs, {
          items: ["web#build (Named)", "web#build (Inferred)", "docs#test (--task flag)"],
          children: [_jsxs(Tab, {
            value: "web#build (Named)",
            children: [_jsxs(_components.p, {
              children: ["通过将 ", _jsx(_components.code, {
                children: "web"
              }), " 包添加为参数，检查 ", _jsx(_components.code, {
                children: "web"
              }), " 包及其依赖的 ", _jsx(_components.code, {
                children: "build"
              }), " 任务的更改："]
            }), _jsxs(_components.p, {
              children: ["¥Check for changes for the ", _jsx(_components.code, {
                children: "build"
              }), " task for the ", _jsx(_components.code, {
                children: "web"
              }), " package and its dependencies by adding the ", _jsx(_components.code, {
                children: "web"
              }), " package as an argument:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo-ignore"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " web"
                    })]
                  })
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "web#build (Inferred)",
            children: [_jsxs(_components.p, {
              children: ["使用 ", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
                children: "自动确定软件包作用域"
              }), " 检查 ", _jsx(_components.code, {
                children: "web"
              }), " 包及其依赖的 ", _jsx(_components.code, {
                children: "build"
              }), " 任务的更改："]
            }), _jsxs(_components.p, {
              children: ["¥Check for changes for the ", _jsx(_components.code, {
                children: "build"
              }), " task for the ", _jsx(_components.code, {
                children: "web"
              }), " package and its dependencies using ", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
                children: "Automatic Package Scoping"
              }), ":"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "cd"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " apps/web"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo-ignore"
                    })]
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "docs#test (--task flag)",
            children: [_jsxs(_components.p, {
              children: ["使用 ", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
                children: "自动确定软件包作用域"
              }), " 和 ", _jsx(_components.code, {
                children: "--task"
              }), " 标志检查 ", _jsx(_components.code, {
                children: "docs"
              }), " 包及其依赖的 ", _jsx(_components.code, {
                children: "test"
              }), " 任务的更改："]
            }), _jsxs(_components.p, {
              children: ["¥Check for changes for the ", _jsx(_components.code, {
                children: "test"
              }), " task for the ", _jsx(_components.code, {
                children: "docs"
              }), " package and its dependencies using ", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
                children: "Automatic Package Scoping"
              }), " and the ", _jsx(_components.code, {
                children: "--task"
              }), " flag:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "cd"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " apps/docs"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo-ignore"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --task=test"
                    })]
                  })]
                })
              })
            })]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "处理结果-handle-the-result",
          children: "处理结果 "
        }), _jsx(_components.p, {
          children: "¥Handle the result"
        }), _jsxs(_components.p, {
          children: ["如果在包或其 ", _jsx(_components.a, {
            href: "/docs/core-concepts/internal-packages",
            children: "内部依赖"
          }), " 中检测到更改，", _jsx(_components.code, {
            children: "turbo"
          }), " 将退出并返回 ", _jsx(_components.code, {
            children: "1"
          }), " 状态码。如果没有检测到任何更改，它将退出并运行 ", _jsx(_components.code, {
            children: "0"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥If changes are detected in the package or its ", _jsx(_components.a, {
            href: "/docs/core-concepts/internal-packages",
            children: "Internal Dependencies"
          }), ", ", _jsx(_components.code, {
            children: "turbo"
          }), " will exit with a ", _jsx(_components.code, {
            children: "1"
          }), " status code. If no changes are detected, it will exit with ", _jsx(_components.code, {
            children: "0"
          }), "."]
        }), _jsxs(_components.p, {
          children: ["使用此状态代码，你可以选择 CI 管道的其余部分应执行的操作。例如，", _jsx(_components.code, {
            children: "1"
          }), " 退出代码可能意味着你应该继续安装依赖并运行任务。"]
        }), _jsxs(_components.p, {
          children: ["¥Using this status code, you can choose what the rest of your CI pipeline should do. For instance, a ", _jsx(_components.code, {
            children: "1"
          }), " exit code likely means that you should move forward with installing dependencies and running tasks."]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["有关更高级的用例，请参阅 ", _jsxs(_components.a, {
        href: "/docs/reference/turbo-ignore",
        children: [_jsx(_components.code, {
          children: "turbo-ignore"
        }), " 参考"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more advanced use cases, see the ", _jsxs(_components.a, {
        href: "/docs/reference/turbo-ignore",
        children: [_jsx(_components.code, {
          children: "turbo-ignore"
        }), " reference"]
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "最佳实践-best-practices",
      children: "最佳实践 "
    }), "\n", _jsx(_components.p, {
      children: "¥Best practices"
    }), "\n", _jsx(_components.h3, {
      id: "依赖缓存-rely-on-caching",
      children: "依赖缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Rely on caching"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 的缓存功能允许你以最小的复杂性创建快速的 CI 流水线。通过 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), " 并使用 ", _jsx(_components.code, {
        children: "--filter"
      }), " 标志来定位要构建的包，Turborepo 将以很小的开销处理大型 monorepo 的变更检测。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo's caching abilities allow you to create fast CI pipelines with minimal complexity. Through ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), " and using the ", _jsx(_components.code, {
        children: "--filter"
      }), " flag to target packages for builds, Turborepo will handle change detection for large monorepos with little overhead."]
    }), "\n", _jsx(_components.p, {
      children: "例如，你的 CI 可以运行这两个命令来快速进行质量检查并构建目标应用："
    }), "\n", _jsx(_components.p, {
      children: "¥For example, your CI could run these two commands to quickly handle quality checks and build your target application:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo run lint check-types test"
          }), "：对整个仓库运行质量检查。任何未更改的包都将进入缓存。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo run lint check-types test"
          }), ": Run quality checks for your entire repository. Any packages that haven't changed will hit cache."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo build --filter=web"
          }), "：使用你在 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中注册的 ", _jsx(_components.code, {
            children: "build"
          }), " 任务构建 ", _jsx(_components.code, {
            children: "web"
          }), " 包。如果 ", _jsx(_components.code, {
            children: "web"
          }), " 包或其依赖没有更改，构建也会命中缓存。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo build --filter=web"
          }), ": Build the ", _jsx(_components.code, {
            children: "web"
          }), " package using the ", _jsx(_components.code, {
            children: "build"
          }), " task you've registered in ", _jsx(_components.code, {
            children: "turbo.json"
          }), ". If the ", _jsx(_components.code, {
            children: "web"
          }), " package or its dependencies haven't changed, the build will also hit cache."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "随着代码库的扩展，你可能会发现更多优化 CI 的具体机会。 - 但依赖缓存是一个很好的起点。"
    }), "\n", _jsx(_components.p, {
      children: "¥As your codebase scales, you may find more specific opportunities to optimize your CI - but relying on caching is a great place to start."
    }), "\n", _jsxs(_components.h3, {
      id: "ci-中的全局-turbo-global-turbo-in-ci",
      children: ["CI 中的全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Global ", _jsx(_components.code, {
        children: "turbo"
      }), " in CI"]
    }), "\n", _jsxs(_components.p, {
      children: ["在 CI 工作流中使用全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " 非常方便，让你可以轻松运行特定于 CI 的命令并利用 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
        children: "自动工作区作用域"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using global ", _jsx(_components.code, {
        children: "turbo"
      }), " is convenient in CI workflows, allowing you to easily run commands specific to your CI and take advantage of ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
        children: "Automatic Workspace Scoping"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["但是，在某些情况下，你可能在使用包管理器安装包之前运行了使用 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的 ", _jsx(_components.code, {
        children: "turbo"
      }), " 命令或脚本。", _jsxs(_components.a, {
        href: "/docs/guides/tools/docker#example",
        children: ["使用 ", _jsx(_components.code, {
          children: "turbo prune"
        }), " 创建 Docker 镜像"]
      }), " 就是一个例子。在这种情况下，全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " 将无法使用 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的版本，因为该版本的二进制文件尚未安装。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥However, in some cases, you may be running ", _jsx(_components.code, {
        children: "turbo"
      }), " commands or scripts that use ", _jsx(_components.code, {
        children: "turbo"
      }), " ", _jsx(_components.strong, {
        children: "before installing packages with your package manager"
      }), ". One example of this is ", _jsxs(_components.a, {
        href: "/docs/guides/tools/docker#example",
        children: ["using ", _jsx(_components.code, {
          children: "turbo prune"
        }), " to create a Docker image"]
      }), ". In this situation, global ", _jsx(_components.code, {
        children: "turbo"
      }), " will not be able to use the version from ", _jsx(_components.code, {
        children: "package.json"
      }), " because the binary for that version hasn't been installed yet."]
    }), "\n", _jsxs(_components.p, {
      children: ["因此，我们建议你将 CI 中 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的全局安装固定到 ", _jsx(_components.code, {
        children: "package.json"
      }), " 的主版本，因为重大更改不会在主版本中引入。你还可以选择通过固定确切版本来提高稳定性，以维护负担为代价来接收补丁版本中的错误修复。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For this reason, we encourage you to ", _jsxs(_components.strong, {
        children: ["pin your global installation of ", _jsx(_components.code, {
          children: "turbo"
        }), " in CI to the major version in ", _jsx(_components.code, {
          children: "package.json"
        })]
      }), " since breaking changes will not be introduced within a major version. You could additionally opt for added stability by pinning an exact version, trading off for maintenance burden to receive bug fixes in patch releases."]
    }), "\n", _jsxs(_components.h3, {
      id: "在-ci-中使用-turbo-run-use-turbo-run-in-ci",
      children: ["在 CI 中使用 ", _jsx(_components.code, {
        children: "turbo run"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsx(_components.code, {
        children: "turbo run"
      }), " in CI"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run"
      }), " 是你在 Turborepo 中工作时最常用的命令，因此为了方便起见，它被别名为 ", _jsx(_components.code, {
        children: "turbo"
      }), "。虽然这对于本地工作非常有用，但还有其他适用于 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的子命令，例如 ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: _jsx(_components.code, {
          children: "turbo prune"
        })
      }), " 和 ", _jsx(_components.a, {
        href: "/docs/reference/generate",
        children: _jsx(_components.code, {
          children: "turbo generate"
        })
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo run"
      }), " is the most common command you will use when working in your Turborepo so it is aliased to ", _jsx(_components.code, {
        children: "turbo"
      }), " for convenience. While this is great for working locally, there are other subcommands for ", _jsx(_components.code, {
        children: "turbo"
      }), " like ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: _jsx(_components.code, {
          children: "turbo prune"
        })
      }), " and ", _jsx(_components.a, {
        href: "/docs/reference/generate",
        children: _jsx(_components.code, {
          children: "turbo generate"
        })
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["我们一直在努力改进 ", _jsx(_components.code, {
        children: "turbo"
      }), "，因此未来可能会添加更多子命令。因此，你可以通过在 CI 中使用 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 来防止命名冲突。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We're always working to make ", _jsx(_components.code, {
        children: "turbo"
      }), " better so we may add more subcommands in the future. For this reason, you can prevent naming collisions by using ", _jsx(_components.code, {
        children: "turbo run"
      }), " in your CI."]
    }), "\n", _jsxs(_components.p, {
      children: ["例如，如果你的 CI 管道中有一个 ", _jsx(_components.code, {
        children: "turbo deploy"
      }), " 命令，它可能与直接内置于 ", _jsx(_components.code, {
        children: "turbo"
      }), " CLI 中的潜在 ", _jsx(_components.code, {
        children: "deploy"
      }), " 子命令冲突。为避免这种情况，请在你的 CI 管道中使用 ", _jsx(_components.code, {
        children: "turbo run deploy"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥As an example, if you have a ", _jsx(_components.code, {
        children: "turbo deploy"
      }), " command in your CI pipelines, it may conflict with a potential ", _jsx(_components.code, {
        children: "deploy"
      }), " subcommand built directly into the ", _jsx(_components.code, {
        children: "turbo"
      }), " CLI. To avoid this, use ", _jsx(_components.code, {
        children: "turbo run deploy"
      }), " in your CI pipeline instead."]
    }), "\n", _jsx(_components.h2, {
      id: "故障排除-troubleshooting",
      children: "故障排除 "
    }), "\n", _jsx(_components.p, {
      children: "¥Troubleshooting"
    }), "\n", _jsx(_components.h3, {
      id: "访问缓存导致构建失败-hitting-cache-results-in-broken-builds",
      children: "访问缓存导致构建失败 "
    }), "\n", _jsx(_components.p, {
      children: "¥Hitting cache results in broken builds"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你的任务在缓存丢失时通过，但在缓存命中时失败，则你可能没有正确配置任务的 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: [_jsx(_components.code, {
          children: "outputs"
        }), " 键"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If your task is ", _jsx(_components.strong, {
        children: "passing when you miss cache but failing when you hit cache"
      }), ", you likely haven't configured ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: ["the ", _jsx(_components.code, {
          children: "outputs"
        }), " key"]
      }), " for your task correctly."]
    }), "\n", _jsx(_components.h3, {
      id: "使用错误的环境变量进行部署-deployment-using-the-wrong-environment-variables",
      children: "使用错误的环境变量进行部署 "
    }), "\n", _jsx(_components.p, {
      children: "¥Deployment using the wrong environment variables"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你没有为任务定义 ", _jsx(_components.code, {
        children: "env"
      }), " 或 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 键，Turborepo 将无法在创建哈希时使用它们。这意味着你的任务即使在不同的环境中也能命中缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you haven't defined the ", _jsx(_components.code, {
        children: "env"
      }), " or ", _jsx(_components.code, {
        children: "globalEnv"
      }), " keys for your task, Turborepo will not be able to use them when creating hashes. This means your task can hit cache despite being in a different environment."]
    }), "\n", _jsxs(_components.p, {
      children: ["检查 ", _jsx(_components.code, {
        children: "env"
      }), " 和 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 键的配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Check your configuration for the ", _jsx(_components.code, {
        children: "env"
      }), " and ", _jsx(_components.code, {
        children: "globalEnv"
      }), " keys."]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: ["现在，你已拥有使用 Turborepo 交付应用所需的一切。要了解更多关于具体用例的信息，请参阅 ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "查看指南"
      }), " 或 ", _jsx(_components.a, {
        href: "/docs/core-concepts",
        children: "深入了解核心概念"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You now have everything you need to ship applications with Turborepo. To learn more about specific use cases, ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "check the Guides"
      }), " or ", _jsx(_components.a, {
        href: "/docs/core-concepts",
        children: "dive deeper into core concepts"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
